import MainC from './components/Main/MainC';
import Sidebar from './components/Sidebar/Sidebar';

const App = () => {
  return (
    <>
      <Sidebar />
      <MainC />
    </>
  );
};
export default App;
